// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../graphql/api/index';

import { MonolithImageSizeFragmentDoc } from '../../monolithImageSize.fragment.generated';
export const ThreeSixtyFragmentDoc = `
    fragment threeSixty on GenericImage {
  url
  large: size(name: LARGE) {
    ...monolithImageSize
  }
  large_x2: size(name: LARGE_X2) {
    ...monolithImageSize
  }
}
    `;